<div class="progress-spinner" *ngIf="loading; else container">
  <p-progressSpinner
    strokeWidth="1"
    [style]="{ width: '50px', height: '50px' }"
  ></p-progressSpinner>
</div>
<ng-template #container>
  <ng-content></ng-content>
</ng-template>
